import { useState, useEffect } from 'react';
import { staffAPI } from '../services/api';

export default function useTurnoverData() {
  const [turnoverData, setTurnoverData] = useState(null);
  const [turnoverLoading, setTurnoverLoading] = useState(true);
  const [showTurnoverInfoModal, setShowTurnoverInfoModal] = useState(false);
  const [turnoverViewMode, setTurnoverViewMode] = useState('ttm');
  const [showCalculationDetails, setShowCalculationDetails] = useState(false);

  useEffect(() => {
    const fetchTurnoverData = async () => {
      try {
        setTurnoverLoading(true);
        const response = await staffAPI.getTurnoverMetrics();
        if (response.data.success) {
          setTurnoverData(response.data.data);
        }
      } catch (error) {
        console.error('❌ Turnover data failed to load:', error?.message);
        setTurnoverData(null);
      } finally {
        setTurnoverLoading(false);
      }
    };
    fetchTurnoverData();
  }, []);

  return {
    turnoverData,
    turnoverLoading,
    turnoverViewMode,
    setTurnoverViewMode,
    showTurnoverInfoModal,
    setShowTurnoverInfoModal,
    showCalculationDetails,
    setShowCalculationDetails,
  };
}
